import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let pending = null;

export function useMeta() {
  const [meta, setMeta] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/meta").then((r) => (cache = r.data));
    pending.then(setMeta).catch(() => {});
  }, []);
  return meta;
}
